import { render, staticRenderFns } from "./clock2.vue?vue&type=template&id=1d247c2c&"
import script from "./clock2.vue?vue&type=script&lang=js&"
export * from "./clock2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports